import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../pages/Homepage.css";
import footerLogo from "./Homepage/Images/footerLogo.png";
import { Link } from 'react-router-dom';
const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <div className="Footer_all">
        <div className="row container mx-auto ">
          <div className="col-12 col-md-6 ">
            <div className="borderstyle">
              <img src={footerLogo} alt="Footer Logo" />
              <p className="footer_fir_p">©️  {new Date().getFullYear()} COPYRIGHT - Vaultwave Technologies Private Limited</p>
              <a className="footer_fir_a" href="mailto:hello@edgepay.in">hello@edgepay.in</a>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div>
              <ul className="d-block d-md-flex items-center mb-5 mb-md-0 justify-content-start all_links gap-4">
                <li><Link to="/privacy-and-policy" onClick={handleLinkClick}>Privacy Policy</Link></li>
                <li><Link to="/terms-and-conditions" onClick={handleLinkClick}>Terms & Conditions</Link></li>
                <li><Link to="/refund-policy" onClick={handleLinkClick}>Refund Policy</Link></li>
                <li><Link to="/contact" onClick={handleLinkClick}>Contact Us</Link></li>
                <li><Link to="/about" onClick={handleLinkClick}>About Us</Link></li>
              </ul>
              <p className="footer_add">
                Shop No. 203 <br />
                II Floor, Hiltan Arcade Shopping Center, <br />
                Evershine City <br />
                Gokhivare, Vasai East, Vasai, Mumbai - 401208.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
